import {
  ChangeDetectionStrategy,
  Component,
  computed,
  EnvironmentInjector,
  inject,
  input,
  Signal,
} from '@angular/core';
import { map, Observable, of, switchMap } from 'rxjs';
import { MatBadgeModule } from '@angular/material/badge';
import { NgTemplateOutlet } from '@angular/common';
import { AppNavigationItem } from '../../app.navigation';
import { TranslateModule } from '@ngx-translate/core';
import { IState } from '../../entity-state/model/state.interface';
import { toObservable, toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-navigation-label',
  templateUrl: './navigation-label.component.html',
  styleUrls: ['./navigation-label.component.scss'],
  imports: [MatBadgeModule, NgTemplateOutlet, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationLabelComponent {
  private readonly _injector = inject(EnvironmentInjector);

  private readonly _stateProvider = computed(() =>
    this._loadStateProvider(this.navigationItem())
  );

  readonly showBadge = computed(() => this._stateProvider() !== undefined);

  readonly incompleteCount = toSignal(
    this._getIncompleteEntityCount$(this._stateProvider),
    {
      initialValue: 0,
    }
  );

  readonly navigationItem = input.required<AppNavigationItem>();

  private _getIncompleteEntityCount$(
    provider: Signal<IState<any> | undefined>
  ): Observable<number> {
    return toObservable(provider).pipe(
      switchMap(provider => {
        if (provider) {
          return provider.getIncompleteEntities();
        }
        return of([]);
      }),
      map(values => values.length)
    );
  }

  private _loadStateProvider(
    appRoute: AppNavigationItem | undefined
  ): IState<any> | undefined {
    const stateProvider = appRoute?.stateProvider;

    if (!stateProvider) {
      return undefined;
    }

    return this._injector.get(stateProvider, undefined);
  }
}
